import { IPaginatedOrgCustomerRelationship } from "@novel/shared/interfaces/OrgCustomerRelationship";
import { NovelVendorSubReducer } from "@vendor-portal/redux/vendorTypedRedux";

export interface ICustomersReducerState extends IPaginatedOrgCustomerRelationship {
    isLoading: boolean;
}

const initialState: ICustomersReducerState = {
    isLoading: true,
    totalCount: 0,
    totalPages: 0,
    pageSize: 0,
    pageNumber: 0,
    data: [],
};

export const customerRelationsReducer: NovelVendorSubReducer<ICustomersReducerState> = (
    state = initialState,
    action,
) => {
    switch (action.type) {
        case "LOADING_CUSTOMERS": {
            return {
                ...state,
                isLoading: true,
            };
        }

        case "ERROR_LOADING_CUSTOMERS": {
            return {
                ...state,
                isLoading: false,
            };
        }

        case "LOADED_CUSTOMERS": {
            return {
                ...state,
                isLoading: false,
                ...(action.payload.customers ?? {}),
            };
        }

        default:
            return state;
    }
};
